import {RFC3339} from "./datetime";
import {Base64, CursorToken} from "./utils";
import {Cipher} from "./cipher";
import {BillingAddress} from "./address";

export interface Ad {
  id: string;
  authorId: string;
  images: string[];
  titleImageIndex: number;
  category: Category;
  adType: AdType;
  title: string;
  description: string;
  cipher: Cipher;
  priceType: PriceType;
  price: number;
  publicationDate: RFC3339[];
  created: RFC3339;
  expired: RFC3339;
  reserved: boolean;
  validated: boolean;
  deleted: RFC3339;
}

export interface AdList {
  ads: Ad[];
  nextPageToken: CursorToken;
  pageSize: number;
}

export interface CreateAd {
  authorId: string;
  transferOldImages: boolean;
  previousAdId: string;
  imageData: Base64[];
  imageContentType: string[];
  titleImageIndex: number;
  category: Category;
  adType: AdType;
  title: string;
  description: string;
  cipher: Partial<Cipher>;
  priceType: PriceType;
  price: number;
  publicationDate: RFC3339[];
  billingAddress: BillingAddress;
}

export interface Category {
  name: string;
  subName: string;
  localityName: string | null;
}

export interface SubCategory {
  masterCategory: string,
  name: string,
  payable: boolean,
  adTypes: AdType[]
}

export interface HolidayShift {
  appearanceDateOld: Date;
  appearanceDateNew: Date;
  deadlineOld: Date;
  deadlineNew: Date;
}

export interface CancelledPublication {
  id?: string;
  title?: string;
  date: Date;
}

export enum AdType {
  OFFER = "OFFER",
  WANTED = "WANTED",
  GOOD_DEED = "GOOD_DEED",
}

export enum PriceType {
  FP = "FP" ,
  VHB = "VHB" ,
}
